module.exports = __webpack_public_path__ + "static/media/small-calendar.e7e5b72f.png";